import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

export const salaryInsightTextCategoryCreate  = (params = '') => Http.post('/salary-insight-text-categories', params)
export const salaryInsightTextCategoriesList  = (params = '') => Http.get(`/salary-insight-text-categories${serialize(params)}`)
export const salaryInsightTextCategoryByID    = (params = '') => Http.get(`/salary-insight-text-categories/${params}`)
export const salaryInsightTextCategoryUpdate  = (params = '') => Http.put(`/salary-insight-text-categories/${params.id}`, params)
export const salaryInsightTextCategoryDestroy = (params = '') => Http.delete(`/salary-insight-text-categories/${params.id}`)
